import { Routes } from '@angular/router';
import { AI_AGENTS_SLUGS, FORM_ROUTE_PARAMS } from '@features/ai-agents/ai-agents.routes';

export const AUTO_ASSIGNMENTS_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: AI_AGENTS_SLUGS.table,
    },
    {
        path: AI_AGENTS_SLUGS.table,
        title: 'Auto-assignments',
        loadComponent: () =>
            import(
                '@features/auto-assignments/auto-assignment-table/auto-assignment-table.component'
            ).then(m => m.AutoAssignmentTableComponent),
    },
    {
        path: AI_AGENTS_SLUGS.templates,
        title: 'Select Template',
        loadComponent: () =>
            import(
                '@features/auto-assignments/auto-assignment-templates/auto-assignment-templates.component'
            ).then(m => m.AutoAssignmentTemplatesComponent),
    },
    {
        path: AI_AGENTS_SLUGS.templateForm,
        title: 'Create from Template',
        loadComponent: () =>
            import(
                '@features/auto-assignments/auto-assignment-modal/auto-assignment-template-form.component'
            ).then(m => m.AutoAssignmentTemplateFormComponent),
    },
    {
        path: `${AI_AGENTS_SLUGS.templateForm}/:${FORM_ROUTE_PARAMS.id}`,
        title: 'Edit from Template',
        loadComponent: () =>
            import(
                '@features/auto-assignments/auto-assignment-modal/auto-assignment-template-form.component'
            ).then(m => m.AutoAssignmentTemplateFormComponent),
    },
    {
        path: AI_AGENTS_SLUGS.form,
        title: 'New auto-assignment',
        loadComponent: () =>
            import(
                '@features/auto-assignments/auto-assignment-form/auto-assignment-form.component'
            ).then(m => m.AutoAssignmentFormComponent),
    },
    {
        path: `${AI_AGENTS_SLUGS.form}/:${FORM_ROUTE_PARAMS.id}`,
        title: 'Edit auto-assignment',
        loadComponent: () =>
            import(
                '@features/auto-assignments/auto-assignment-form/auto-assignment-form.component'
            ).then(m => m.AutoAssignmentFormComponent),
    },
    {
        path: '**',
        redirectTo: AI_AGENTS_SLUGS.table,
    },
];
